import styled from 'styled-components'
import { BREAKPOINTS } from '../../constants/breakpoints'

export const SimulateDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Ubuntu;
  padding-bottom: 40px;

  .button-create {
    display: flex;
    padding-right: 0;
    > div {
      margin-left: auto;
    }
  }

  .button-action {
    margin-left: auto;
    button {
      margin: 0;
    }
  }

  .DFGreyBox {
    @media ${BREAKPOINTS.xs} {
      margin: 0;
    }
  }
`

export const PolicyDataContainer = styled.div`
  width: 60%;
  padding-left: 50px;
  padding-right: 50px;
`

export const PolicyDataElements = styled.div`
  > div {
    width: 100%;

    @media ${BREAKPOINTS.md} {
      width: 50%;
    }

    .DFdatePicker,
    .DFnumberField {
      margin-top: 0;
    }
  }

  @media ${BREAKPOINTS.md} {
    display: flex;
    gap: 32px;
  }
`

export const EntityContainer = styled.div`
  .nif .DFtextField {
    margin-top: 0px;
  }
`
